import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Image from './Image';
import { convertMJD, mjdDifferenceInMinutes, displayMinutes } from '../utils/timeUtils';
import './Camera.css';

const camName = 'acam';

function ACamera(props) {
  const { camData, imgSrc } = props;
  const { obs, mag5sig, fwhm, zp, skymu, mjd } = camData;
  let minSinceChange = mjdDifferenceInMinutes(mjd, convertMJD(new Date()));

  return (
    <Grid
      container
      direction='row'
      className='cam-card in-range'
    >
      <Grid item xs={6}>
        <Image imgSrc={imgSrc} />
        {
          minSinceChange > 15 && (
            <div>
              <p>{displayMinutes(minSinceChange)}</p>
            </div>)
        }
      </Grid>
      <Grid item xs={5}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '2px' }}>{obs || camName.toUpperCase()}</TableCell>
              </TableRow>
            </TableHead>
          </Table>
          <Table>
            <TableBody>
              <TableRow key='zp'>
                <TableCell style={{ padding: '2px' }}>ZP</TableCell>
                <TableCell style={{ padding: '2px' }}>
                  {(zp == null) ? 'N/A' : parseFloat(zp).toFixed(2)}
                </TableCell>
              </TableRow>
              <TableRow key='fwhm'>
                <TableCell style={{ padding: '2px' }}>FWHM</TableCell>
                <TableCell style={{ padding: '2px' }}>
                  {(fwhm == null) ? 'N/A' : parseFloat(fwhm).toFixed(2)}
                </TableCell>
              </TableRow>
              <TableRow key='skymu'>
                <TableCell style={{ padding: '2px' }}>sky μ</TableCell>
                <TableCell style={{ padding: '2px' }}>
                  {(skymu == null) ? 'N/A' : parseFloat(skymu).toFixed(2)}
                </TableCell>
              </TableRow>
              <TableRow key='mag5sig'>
                <TableCell style={{ padding: '2px' }}>5σ</TableCell>
                <TableCell style={{ padding: '2px' }}>
                  {(mag5sig == null) ? 'N/A' : parseFloat(mag5sig).toFixed(2)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default ACamera;